import { put, takeLatest, call, all } from 'redux-saga/effects';
import Api from 'guardian/reducers/Api';

const FETCH_API_KEYS = 'guardian/apiKeys/FETCH_API_KEYS';
const FETCH_API_KEYS_SUCCESS = 'guardian/apiKeys/FETCH_API_KEYS_SUCCESS';
const FETCH_API_KEYS_FAILURE = 'guardian/apiKeys/FETCH_API_KEYS_FAILURE';

const REGENERATE_API_KEY = 'guardian/apiKeys/REGENERATE_API_KEY';
const REGENERATE_API_KEY_SUCCESS = 'guardian/apiKeys/REGENERATE_API_KEY_SUCCESS';
const REGENERATE_API_KEY_FAILURE = 'guardian/apiKeys/REGENERATE_API_KEY_FAILURE';

const CREATE_API_KEY = 'guardian/apiKeys/CREATE_API_KEY';
const CREATE_API_KEY_SUCCESS = 'guardian/apiKeys/CREATE_API_KEY_SUCCESS';
const CREATE_API_KEY_FAILURE = 'guardian/apiKeys/CREATE_API_KEY_FAILURE';

const CLEAR_NEW_API_KEY = 'guardian/apiKeys/CLEAR_NEW_API_KEY';

export const actions = {
  fetchApiKeys: () => ({ type: FETCH_API_KEYS }),
  regenerateApiKey: (accountId) => ({ type: REGENERATE_API_KEY, payload: accountId }),
  createApiKey: (data) => ({ type: CREATE_API_KEY, payload: data }),
  clearNewApiKey: () => ({ type: CLEAR_NEW_API_KEY }),
};

const initialState = {
  list: [],
  newApiKey: null,
  loading: false,
  error: null,
};

export default function apiKeysReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_API_KEYS:
    case REGENERATE_API_KEY:
    case CREATE_API_KEY:
      return { ...state, loading: true, error: null };

    case FETCH_API_KEYS_SUCCESS:
      return { ...state, loading: false, list: action.payload };

    case REGENERATE_API_KEY_SUCCESS:
    case CREATE_API_KEY_SUCCESS:
      return {
        ...state,
        loading: false,
        newApiKey: action.payload,
        list: state.list.map((key) =>
          key.id === action.payload.id
            ? { ...key, api_key_hint: action.payload.api_key_hint }
            : key
        ),
      };

    case FETCH_API_KEYS_FAILURE:
    case REGENERATE_API_KEY_FAILURE:
    case CREATE_API_KEY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CLEAR_NEW_API_KEY:
      return { ...state, newApiKey: null };

    default:
      return state;
  }
}

function* fetchApiKeysSaga() {
  try {
    const response = yield call(Api.fetchApiKeys);
    yield put({ type: FETCH_API_KEYS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: FETCH_API_KEYS_FAILURE, payload: error.message });
  }
}

function* regenerateApiKeySaga(action) {
  try {
    const response = yield call(Api.regenerateApiKey, action.payload);
    yield put({ type: REGENERATE_API_KEY_SUCCESS, payload: response.data });
    yield put({ type: FETCH_API_KEYS });
  } catch (error) {
    yield put({ type: REGENERATE_API_KEY_FAILURE, payload: error.message });
  }
}

function* createApiKeySaga(action) {
  try {
    const response = yield call(Api.createApiKey, action.payload);
    yield put({ type: CREATE_API_KEY_SUCCESS, payload: response.data });
    yield put({ type: FETCH_API_KEYS });
  } catch (error) {
    yield put({ type: CREATE_API_KEY_FAILURE, payload: error.message });
  }
}

export function* apiKeysSagas() {
  yield all([
    takeLatest(FETCH_API_KEYS, fetchApiKeysSaga),
    takeLatest(REGENERATE_API_KEY, regenerateApiKeySaga),
    takeLatest(CREATE_API_KEY, createApiKeySaga),
  ]);
}
